/* eslint-disable import/no-cycle */
import { usersService } from '../../utils/services/users.service';

const state = {
  current_user: {},
  permissions: {},
};

const actions = {
  fetchCurrentUser({ commit, dispatch }) {
    return usersService.currentUser()
      .then(response => {
        commit('currentUserSave', response.data);
      }, () => {
        commit('currentUserSave', {});
        dispatch('alert/showToast', { type: 'error', message: 'Failed fetching user informations' }, { root: true });
      });
  },
  fetchPermissions({ commit, dispatch }) {
    return usersService.getUserPermission()
      .then(response => {
        commit('permissionsSave', response.data);
      }, () => {
        commit('permissionsSave', {});
        dispatch('alert/showToast', { type: 'error', message: 'Failed fetching user permissions' }, { root: true });
      });
  },
};

const mutations = {
  currentUserSave(state, user) {
    state.current_user = user;
  },
  permissionsSave(state, permissions) {
    state.permissions = permissions;
  },
};

const getters = {
  currentUser(state) {
    return state.current_user;
  },
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
